import { OrderFormInputData } from '../../models/order-form.model';

export const ORDER_FORM_EVENTS = {
	OPEN: 'order-form.open',
	UPDATE: 'order-form.update'
} as const;

export type OrderFormEventData = OrderFormInputData;
